// FIXME (maybe): jspc screaming for duplication of imports which hinders we make the code cleaner
// jscpd:ignore-start
import classNames from 'classnames';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import { useMembership } from '../../../hooks/users';
import useSelector from '../../../hooks/useSelector';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
  GENERAL_DL_SWITCH_CLASS,
} from '../PriceViewer';
// jscpd:ignore-end

const RetailTradeSwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
}> = ({ wrapAnalytics }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const hasMembership = useMembership();
  const { showInstitutionalTrades, institutionalTradesVersion } = useSelector(
    state => state.preference
  );

  return (
    <OverlayTrigger
      placement="right"
      overlay={
        hasMembership ? (
          <span></span>
        ) : (
          <Tooltip id="retail-trades-tooltip">
            {t('feature-requires-vip')}
          </Tooltip>
        )
      }
    >
      <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
        <div
          className={classNames(GENERAL_DL_SWITCH_CLASS, {
            checked: showInstitutionalTrades,
            disabled: !hasMembership,
          })}
          onClick={wrapAnalytics('institutional-trades', () =>
            dispatch(
              preferenceActions.setShowInstitutionalTrades(
                !showInstitutionalTrades
              )
            )
          )}
        >
          {t('institutional-trades')}
        </div>
        {['v1', 'v2'].map(interval => (
          <div
            key={interval}
            className={
              DL_SWITCH_CLASS_NAME +
              (showInstitutionalTrades &&
              institutionalTradesVersion === interval
                ? ' checked'
                : '') +
              (showInstitutionalTrades ? '' : ' disabled')
            }
            onClick={wrapAnalytics(
              `institutionalTrades-version-${interval}`,
              () => {
                dispatch(
                  preferenceActions.setInstitutionalTradesVersion(interval)
                );
              }
            )}
          >
            {interval}
          </div>
        ))}
      </div>
    </OverlayTrigger>
  );
};

export default RetailTradeSwitch;
